export enum TipoDeclinioPropostaEnum {
  DECLINIO_MOTIVO = 1,
  DECLINIO_PORTABILIDADE = 2,
  DECLINIO_25_DIAS = 3,
}
